import React, { useState, useEffect } from "react";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
  DropDown,
} from "../../../components/commons";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { Label, Input, Row, Col } from "reactstrap";
import { DeleteIcon, CalenderIcon } from "../../../components/Icon";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RootState } from "../../../redux/rootReducers";
import {
  resetOpenItemsError,
  resetOpenItemsSuccess,
} from "../../../redux/openItems";
import {
  getAllJobsTrackerListAction,
  resetJobTrackerListing,
} from "../../../redux/listing";
import { addAdminOpenItemsAction } from "../../../redux/openItems";
import { resetSession } from "../../../redux/auth";
import { ClientType } from "../../../redux/auth/authTypes";
import { JobTrackerListingType } from "../../../redux/listing/listingTypes";
import {
  ItemTypes,
  AddOpenItemPayload,
} from "../../../commonTypes/openItemsTypes";
import { GetJobTrackerListingPayload } from "../../../commonTypes/listing";
import {
  handleDate,
  returnInputFieldLength,
  reverseDate,
} from "../../../utils/commonFunctions";
import { FORMATS } from "../../../constant/openItemConst";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { GetPathBeforeClientCode } from "../../../components/commons/UserManagement";
import { getJobsListAction, resetJobsList } from "../../../redux/jobs";

const ITEM_DATA: ItemTypes[] = [
  {
    item_name: "",
    format: {},
    due_date: null,
  },
];

type dropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};

type AppProps = {
  fetching: boolean;
  success: number | null;
  token: string | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetOpenItemsError: () => void;
  dispatchResetOpenItemsSuccess: () => void;
  clientList: ClientType[] | [];
  jobTrackerListing: [] | JobTrackerListingType[];
  dispatchGetClientsActiveJobAction: (
    data: any
  ) => void;
  dispatchResetJobTrackerListing: () => void;
  dispatchAddAdminOpenItemsAction: (data: any) => void;
  dispatchResetSession: () => void;
  history: any;
};

const AdminOpenItemAdd = ({
  fetching,
  clientList,
  success,
  statusCode,
  token,
  error,
  jobTrackerListing,
  dispatchResetOpenItemsError,
  dispatchResetOpenItemsSuccess,
  dispatchGetClientsActiveJobAction,
  dispatchResetJobTrackerListing,
  dispatchAddAdminOpenItemsAction,
  dispatchResetSession,
  history,
}: AppProps) => {
  const [clientId, setClientId] = useState<any>(null);
  const [itemData, setItemData] = useState(
    JSON.parse(JSON.stringify(ITEM_DATA))
  );
  const [finalClientList, setFinalClientList] = useState<
    dropDownItemType[] | []
  >([]);
  const [finalJobList, setFinalJobList] = useState<dropDownItemType[] | []>([]);
  const [summary, setSummary] = useState<string>("");
  const [selectedJobDetails, setSelectedJobDetails] = useState<any>([]);
  const [isOpenItemAddUrlPresent,setIsOpenItemAddUrlPresent]=useMenuCheck()
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });

  const [jobSelected, setJobSelected] = useState<any>({
    value: null,
    label: "Select Job Type",
  });
 const url=history?.location?.pathname

  useEffect(() => {
    setIsOpenItemAddUrlPresent(GetPathBeforeClientCode(url),"url")
    dispatchResetOpenItemsError();
    dispatchResetOpenItemsSuccess();
    dispatchResetJobTrackerListing();
  }, []);

  useEffect(()=>{
   if(isOpenItemAddUrlPresent===false){
    history.push("/access-denied")
   }
  },[isOpenItemAddUrlPresent])

  useEffect(() => {
    if (clientList.length > 0) {
      let finalClientData = clientList?.map((client: ClientType) => {
        return {
          value: client.client_code,
          label: `(${client.client_code})  ${client.company_name}`,
        };
      });

      setFinalClientList(finalClientData);
    }
  }, [clientList]);

  useEffect(() => {
    if (jobTrackerListing.length > 0) {
      let finalJobsData = jobTrackerListing?.map((job: any) => {
        return {
          value: job.job_id,
          label: `${job.job_type}_${job.period_ended}(${job.job_id})`,
        };
      });

      setFinalJobList(finalJobsData);
    } else {
      setFinalJobList([]);
    }
  }, [jobTrackerListing]);

  const handleChange = (dataKey: any, value: any, index: number) => {
    let temp = itemData;
    temp[index][dataKey] = handleDate(value);
    setItemData([...temp]);
  };

  const renderItems = () => {
    let arr: any[] = [];

    itemData &&
      itemData.map((item: any, i: number) => {
        if (item.hasOwnProperty("item_name")) {
          arr.push(
            <div className="col-6 mt-2 mb-2">
              <Input
                type="text"
                placeholder="item name"
                value={item["item_name"] || ""}
                maxLength={100}
                onChange={(e) => handleChange("item_name", e.target.value, i)}
              />
              <p
                className="text-right mt-1 text-muted m-0 p-0"
                style={{ fontSize: "11px" }}
              >
                {returnInputFieldLength(item["item_name"].length, 100)}
              </p>
            </div>
          );
        }

        if (item.hasOwnProperty("format")) {
          arr.push(
            <div className="col-3 mt-2 mb-2">
              <DropDown
                placeholder="Choose Client.."
                options={FORMATS}
                handleChange={(option) => handleChange("format", option, i)}
                value={item["format"]}
              />
              {/* <Input 
                            type="text" 
                            placeholder="Format" 
                            onChange={(e) => handleChange('format', e.target.value, i)}
                        /> */}
            </div>
          );
        }

        if (item.hasOwnProperty("due_date")) {
          arr.push(
            <div className="col-md-3 mt-2 mb-2">
              <Row>
                <Col>
                   <div className="form-group">
                    <div className='date-picker-wraper mr-0'>
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      // selected={item['due_date'] || null}
                      selected={
                        item["due_date"]
                          ? new Date(
                              moment(
                                `${item["due_date"]}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(value: any) =>
                        handleChange(
                          "due_date",
                          moment(value).format("YYYY-MM-DD"),
                          i
                        )
                      }
                      selectsStart
                      showMonthDropdown
                      showYearDropdown
                      startDate={null}
                      endDate={null}
                      minDate={new Date()}
                      className="form-control"
                    />
                    <span className="calender-icon" style={{ right: '25px', cursor: 'pointer', top: "7px" }}>
                      <CalenderIcon />
                    </span>
                    </Label>
                    </div>
                    </div>
                </Col>
                <Col xs={1} className="m-0 p-0">
                  {itemData.length > 1 ? (
                    <span onClick={() => handleRemoveRow(i)}>
                      <DeleteIcon />
                    </span>
                  ) : null}
                </Col>
              </Row>
            </div>
          );
        }
      });
    return arr;
  };

  const handleRemoveRow = (index: any) => {
    let temp = JSON.parse(JSON.stringify(itemData));
    temp.splice(index, 1);
    setItemData(temp);
  };
  const handleAddRow = () => {
    let temp: any = JSON.parse(JSON.stringify(itemData));
    temp.push(...JSON.parse(JSON.stringify(ITEM_DATA)));
    setItemData(temp);
  };

  const handleChangeClient = (client: any) => {
    if (client !== clientSelected) {
      setJobSelected({
        value: null,
        label: "Select Job...",
      });
    }
    setClientId(client.value);
    setClientSelected(client);
    if (client && token) {
      dispatchResetJobTrackerListing();
      let finalData = {
        clientCode: client.value,
        token,
        filterStatus: "Open",
      };
      dispatchGetClientsActiveJobAction(finalData);
    }
  };

  const handleChangeJob = (job: any) => {
    setJobSelected(job);

    if (jobTrackerListing && jobTrackerListing.length) {
      jobTrackerListing.map((item: any) => {
        if (item.job_id === job.value) {
          setSelectedJobDetails(item);
        }
      });
    }
  };

  const handleCancel = () => {
    setItemData(JSON.parse(JSON.stringify(ITEM_DATA)));
    history.goBack();
  };

  const validateSubmit = () => {
    if (!clientSelected.value || !jobSelected.value || !summary) return false;

    for (const item in itemData) {
      if (
        itemData[item].due_date === null ||
        (itemData[item].format &&
          Object.keys(itemData[item].format).length === 0 &&
          Object.getPrototypeOf(itemData[item].format) === Object.prototype) ||
        itemData[item].item_name === ""
      ) {
        return false;
      }
    }

    return true;
  };

  const handleSubmit = () => {
    let validation = validateSubmit();
    if (!validation) {
      toast.error("Please provide all the mandetory fields!", {
        duration: 3000,
      });

      return false;
    }

    let tempData = JSON.parse(JSON.stringify(itemData));
    tempData.map((data: any) => (data.format = data.format.value));

    const params: AddOpenItemPayload = {
      client_code: clientSelected.value,
      job_id: selectedJobDetails?.job_id || 0,
      job_type: selectedJobDetails.job_type,
      job_end_date:reverseDate(selectedJobDetails.period_ended),
      summary,
      item_data: tempData,
      token,
    };

    dispatchAddAdminOpenItemsAction(params);
  };

  const redirectToListing = () => {
    history.goBack();
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetOpenItemsError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => dispatchResetOpenItemsError()}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Open Item Added Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetOpenItemsSuccess();
            redirectToListing();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Add Open Items" />
      </div>

      <div className="col-md-12 mt-4">
        <div className="content-area">
          <div className="row">
            <div className="col-6">
              <Label>Select Client<span className='color-red'>*</span></Label>
              <DropDown
                placeholder="Choose Client.."
                options={finalClientList}
                handleChange={handleChangeClient}
                value={clientSelected}
              />
            </div>
            <div className="col-6">
              <Label>Select Job Type<span className='color-red'>*</span></Label>
              <DropDown
                placeholder="Choose Job.."
                options={finalJobList}
                handleChange={handleChangeJob}
                value={jobSelected}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
            <Label>Summary<span className='color-red'>*</span></Label>
              <Input
                type="textarea"
                name="text"
                id="exampleText"
                value={summary}
                onChange={(e) => setSummary(e.target.value)}
                placeholder="Write your summary here..."
                maxLength={250}
              />
              <p className="text-right mt-1" style={{ fontSize: "11px" }}>
                {" "}
                {returnInputFieldLength(summary.length, 250)}
              </p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-6">
              <Label>Item name<span className='color-red'>*</span></Label>
            </div>
            <div className="col-3">
              <Label>Format<span className='color-red'>*</span></Label>
            </div>
            <div className="col-3">
              <Label>Due Date<span className='color-red'>*</span></Label>
            </div>
          </div>
          <div className="row">{renderItems()}</div>

          <div className="row mt-3">
            <div className="col-12">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleAddRow}
              >
                Add More
              </button>
            </div>
          </div>

          <Row>
            <Col xs={12} className="text-right">
              <button className="btn btn-link" onClick={handleCancel}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </Col>
          </Row>
        </div>
      </div>
      {fetching && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  clientList: state.auth.assignedClientsToUserList,
  token: state.auth.token,
  fetching: state.openItems.fetching,
  success: state.openItems.success,
  statusCode: state.openItems.statusCode,
  error: state.openItems.error,
  jobTrackerListing: state.jobs.jobsList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetOpenItemsError: () => dispatch(resetOpenItemsError()),
  dispatchResetOpenItemsSuccess: () => dispatch(resetOpenItemsSuccess()),
  dispatchGetClientsActiveJobAction: (data: any) =>
    dispatch(getJobsListAction(data)),
  dispatchResetJobTrackerListing: () => dispatch(resetJobsList()),
  dispatchAddAdminOpenItemsAction: (data: any) =>
    dispatch(addAdminOpenItemsAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminOpenItemAdd);
